<template>
  <div class="wrap" :style="{ 'filter': 'brightness(' + brightness + '%)', 'height': height - 49 + 'px'}">
    <v-progress-linear v-model="progress"></v-progress-linear>
    <v-btn :style="{width: (100 - widthSize) + '%'}" class="nav-btn left" @click.stop="prev" v-shortkey="['arrowleft']" @shortkey="prev" :ripple="false">
      <v-icon :style="{'left': (widthSize / 3.5) + '%'}">ion-ios-arrow-left</v-icon>
    </v-btn>
    <v-btn :style="{width: (100 - widthSize) + '%'}" class="nav-btn right" @click.stop="next" v-shortkey="['arrowright']" @shortkey="next" :ripple="false">
      <v-icon :style="{'right': (widthSize / 3.5) + '%'}">ion-ios-arrow-right</v-icon>
    </v-btn>
    <div class="book-content" :style="{'width': widthSize + '%', 'background-color': currentColor, 'height': height - 78 + 'px' }"  @mouseenter="over" @mouseleave="out">
      <v-touch :class="{active: hiddenEl}" class="touch-swipe" @swipeleft="next" @swiperight="prev" @tap="tapped" v-if="isMobile"></v-touch>
      <div class="book-page" :class="fontFamily" :style="{ 'font-size': fontSize + 'px', 'columns': cols }" :key="div" enable-resize-watcher @tap="tappedIn" @swipe="tappedIn" @click="tappedIn">
        <transition :name="routeTransition" mode="out-in">
          <router-view class="view" :key="$route.name"></router-view>
        </transition>
      </div>
    </div>
    <footer :class="fontFamily" :style="{ 'font-size': (fontSize - 5) + 'px' }">
      <div v-if="brandReaderUrl">
      <v-btn flat class="HC-footer-button" @click.native.stop="drawer = false, info = false, buyMenu = false, socialMenu = false, drawerRight = false, otherBooks = false" :ripple="false" tag="a" :href="brandReaderUrl" target="_blank">
        <i><img :src="brandLogoUrl"></i>
      </v-btn>
      </div>
      <v-spacer></v-spacer>
      <div class="foots">
      <span><em>{{ this.$route.name }}</em></span> - page <span><em>{{ this.pageNumber }}</em></span> <span v-if="this.totalPages > 1"><em>{{ "/ " + this.totalPages }}</em></span>
      </div>
      <v-spacer></v-spacer>
    </footer>  
  </div>
</template>

<script>
import eventHub from "../event-hub.js";
import Settings from "../components/Settings";

var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

export default {
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: [
        "home",
        "004_Contents",
        "005_Abbreviations",
        "006_Preface",
        "007_Introduction",
        "008_Part01",
        "009_Chapter01",
        "010_Chapter02",
        "011_Chapter03",
        "last"
      ],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/keg3ds/",
      waiting: false
    };
  },
  created: function() {

    document.addEventListener("mousewheel", this.onScroll, false)
    window.addEventListener('resize', this.resize)
    this.resize()
    this.getTtlPages()

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(route => {
      this.routeNames.push(route.name);
    });
    eventHub.$on("fontSizeChanged", newValue => {
      this.fontSize = newValue;
    });
    eventHub.$on("fontFamilyChanged", newValue => {
      this.fontFamily = newValue;
    });
    eventHub.$on("columnsCountChanged", newValue => {
      this.columns = newValue;
      if (this.columns === "Single") {
        this.cols = "1 auto";
      } else if (this.columns === "Auto") {
        this.cols = "2 220px";
      }
    });
    eventHub.$on("widthChanged", newValue => {
      this.widthSize = newValue;
    });
    eventHub.$on("brightnessChanged", newValue => {
      this.brightness = newValue;
    });
  },

  destroyed: function() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated() {
    this.getTtlPages()
    this.resize()
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function(e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        }; 
      };
    };

  },
  mounted() {
    this.resize()

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function(e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style
        .backgroundColor,
      hexDigits = new Array(
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f"
      );
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },
  watch: {
    $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },
    pageNum: newValue => {
      eventHub.$emit("pageNum", newValue);
    },
    ttlPages: newValue => {
      eventHub.$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize() {
      this.height = document.documentElement.clientHeight
    },
    linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(
        window.getComputedStyle(page).getPropertyValue("column-gap"),
        10
      );
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(
        elementOffset / (page.offsetWidth + gap)
      );
      var target = (destinationOffset * (page.offsetWidth + gap)) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        const scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(
          destinationOffset * (page.offsetWidth + gap) / scrollArea * 100
        );
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages() {
      this.$nextTick(function() {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(
          window.getComputedStyle(page).getPropertyValue("column-gap"),
          10
        );

        const scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt(destination, duration = 200, easing = "easeInOutQuart", callback) {
      const easings = {
        linear(t) {
          return t;
        },
        easeInQuad(t) {
          return t * t;
        },
        easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic(t) {
          return t < 0.5
            ? 4 * t * t * t
            : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint(t) {
          return t < 0.5
            ? 16 * t * t * t * t * t
            : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(
          window.getComputedStyle(page).getPropertyValue("column-gap"),
          10
        ),
        offset = page.offsetWidth + gap;

      const start = Math.ceil(page.scrollLeft);

      const startTime =
        "now" in window.performance ? performance.now() : new Date().getTime();

      const documentWidth = Math.max(
        page.scrollWidth || page.offsetWidth || page.clientWidth
      );

      const windowWidth = window.innerWidth || window.clientWidth;

      const destinationOffsetToScroll = start + destination;

      function scroll() {
        const now =
          "now" in window.performance
            ? performance.now()
            : new Date().getTime();
        const time = Math.min(1, (now - startTime) / duration);
        const timeFunction = easings[easing](time);
        page.scroll(
          Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start),
          0
        );
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(() => {
        this.waiting = false
      }, 250);
    },

    next: function(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
        gap = parseInt(
          window.getComputedStyle(page).getPropertyValue("column-gap"),
          10
        ),
        offset = page.offsetWidth + gap,
        index = this.routeNames.indexOf(this.$route.name);

      const scrollArea = page.scrollWidth - page.offsetWidth;
      const windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      const scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (
        page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 &&
        pctScrolled !== 100
      ) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);

      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(
          pageNum * (page.offsetWidth + gap) / scrollArea * 100
        );
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(
        pageNum * (page.offsetWidth + gap) / scrollArea * 100
      );
      this.progress = pctScrolled;
    },
    prev: function(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
        gap = parseInt(
          window.getComputedStyle(page).getPropertyValue("column-gap"),
          10
        ),
        offset = page.offsetWidth + gap,
        index = this.routeNames.indexOf(this.$route.name);

      const scrollArea = page.scrollWidth - page.offsetWidth;

      const scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);

      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(
          pageNum * (page.offsetWidth + gap) / scrollArea * 100
        );
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(
        pageNum * (page.offsetWidth + gap) / scrollArea * 100
      );
      this.progress = pctScrolled;
    },
    over: function() {
      this.isOver = true;
    },
    out: function() {
      this.isOver = false;
    },
    onScroll: function(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
          gap = parseInt(
            window.getComputedStyle(page).getPropertyValue("column-gap"),
            10
          ),
          deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
          end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
          offset = page.offsetWidth + gap;

        const scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(
          pageNum * (page.offsetWidth + gap) / scrollArea * 100
        );
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(
              pageNum * (page.offsetWidth + gap) / scrollArea * 100
            );
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return
            }
            this.waiting = true;
            
            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(
              pageNum * (page.offsetWidth + gap) / scrollArea * 100
            );
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          (window.requestAnimationFrame && requestAnimationFrame(tick)) ||
            setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function() {
      let check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    }
  },
  components: {
    Settings
  }
};
</script>



// WEBPACK FOOTER //
// Reader.vue?d6ba7894